import { createFileRoute } from '@tanstack/react-router';
import { AutomationsMetricsForward } from '@/pages/workspaces/automations/[campaignId]/metrics/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/metrics')({
  component: AutomationsMetricsForward,
});
